<!-- <h2 mat-dialog-title>{{ 'category' | translate }}</h2> -->
<div mat-dialog-content>
    <div>
        {{ 'schedule_resused' | translate: {schedule: getNonEmptyText(data.scheduleText)} }}
    </div>
    <app-data-table [data]="data.reusedInMenuItems" [columns]="columns">
    </app-data-table>
</div>
<div mat-dialog-actions align="end">
    <!-- <button mat-button [mat-dialog-close]="data">{{ 'ok' | translate }}</button> -->
    <button mat-button (click)="closeDialog()">{{ 'close' | translate }}</button>
</div>
